import PropTypes from 'prop-types';
import {
  arrayOf as arrayType, params, shape as shapeType, string as stringType
} from '@thd-nucleus/data-sources';

export const dataModelRelatedSearch = {
  relatedSearchModel: params({ itemId: stringType(), navParam: stringType(), storeId: stringType() }).shape({
    relatedSearch: arrayType(shapeType({
      url: stringType(),
      anchor: stringType()
    }))
  }),
  searchModel: params({ keyword: stringType(), storeId: stringType() }).shape({
    relatedResults: shapeType({
      relatedKeywords: arrayType(shapeType({
        keyword: stringType()
      }))
    })
  })
};

export const propTypesRelatedSearch = {
  itemId: PropTypes.string,
  navParam: PropTypes.string,
  storeId: PropTypes.string,
  searchData: PropTypes.shape({}),
  keyword: PropTypes.string
};

export const relatedSearchThemeProps = {
  hideRelatedSearch: PropTypes.bool
};

export const relatedSearchDefaultThemeProps = {
  hideRelatedSearch: false
};